import axios from 'axios';
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const sendNotification = async ({ title, message, externalUserId }) => {
  console.log("externalUserId",title, message, externalUserId)
  try {
    const response = await axios.post(`${BACKEND}/send-notification/all`, {
      title,
      message,
      externalUserId, // This will be the user ID (if applicable)
    });

    return response;
  } catch (error) {
    console.error('Error in sendNotification:', error);
    throw error; // Throw error to be handled in the component
  }
};

export { sendNotification };
